

import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { MdSubscriptions, MdOutlinePermMedia, MdOutlineGroup, MdOutlineRule, MdOutlineSettings, MdOutlineAdd } from "react-icons/md"
import { RiImageAiFill, RiFilmLine } from "react-icons/ri";
import { LuBrainCircuit } from "react-icons/lu";


import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger, DropdownMenuCheckboxItem} from "@/components/ui/shadcn/dropdown-menu"
import { useShow } from '@/contexts/ShowContext'
import { useUser, UserRole } from '@/contexts/UserContext'

import { UserRoles } from '@/contexts/UserContext'

export default function Navbar() {
  const { pathname } = useLocation()
  const {shows, show, updateShow, switchShow} = useShow()
  const [showsVisible, setShowsVisible] = useState(false)
  const {user, logout, changeAccount} = useUser()

  const isActive = (path) => {
    return pathname.indexOf(path)=== 0 ? 'text-primary' : 'text-secondary-foreground hover:text-primary'
  }

  const handleChangeShow = async(showId) => {
    await updateShow(showId)
    window.location.reload()
    setShowsVisible(false)
  }

  return (
    <nav className="bg-background border-r h-screen w-20 fixed top-0 left-0 z-10">
        <div className="flex flex-col items-center justify-between pb-8 h-full">
            <div className="flex flex-col items-center gap-10">
                <div className="flex flex-col items-center gap-6 border-b pb-10">
                    <div className="flex justify-center pt-5 h-20">
                        <Link to="/">
                            <svg width="2.5em" height="2em" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9062 12.8588L8.30165 0H0L10.6397 18H15.9062V12.8588Z" fill="white"></path><path d="M26.828 12.8588L19.2235 0H10.9194L21.5591 18H26.828V12.8588Z" fill="white"></path><path d="M29.3655 2.99306L26.7335 3.00694V8.90741L31.9999 0H21.4646" fill="#e5ff00"></path></svg>
                        </Link>
                    </div>
                    
                    <div className="overflow-hidden rounded-full w-11 h-11 relative cursor-pointer bg-secondary justify-center items-center flex hover:outline-2 hover:outline-primary" onClick={() => setShowsVisible(true)}>
                        {!show?.thumbnail_url && <span className='text-secondary-foreground font-bold text-xl'>{show?.name.charAt(0)}</span>}
                        {show?.thumbnail_url && <img src={show?.thumbnail_url} alt={show?.name} decoding="async" style={{position:'absolute',width:'100%',height:'100%',objectFit:'cover'}} className='object-cover' />}
                    </div>
                </div>
            
                <div className="flex flex-col items-center gap-10">
                    <Link to="/show/episodes" className={`${isActive('/show/episodes')}`}>
                        <MdSubscriptions className="w-6 h-6" />
                    </Link>
                    <UserRole role='editor'>
                        <Link to="/show/assets" className={`${isActive('/show/assets')}`}>
                            <MdOutlinePermMedia className="w-6 h-6" />
                        </Link>
                        <Link to="/show/studio" className={`${isActive('/show/studio')}`}>
                            <RiImageAiFill className="w-6 h-6" />
                        </Link>
                        <Link to="/show/agent" className={`${isActive('/show/agent')}`}>
                            <LuBrainCircuit className="w-6 h-6" />
                        </Link>
                        <Link to="/show/timelines" className={`${isActive('/show/timelines')}`}>
                            <RiFilmLine className="w-6 h-6" />
                        </Link>
                    </UserRole>
                    <UserRole role='manager'>
                        <Link to="/show/characters" className={`${isActive('/show/characters')}`}>
                            <MdOutlineGroup className="w-6 h-6" />
                        </Link>
                        <Link to="/show/instructions" className={`${isActive('/show/instructions')}`}>
                            <MdOutlineRule className="w-6 h-6" />
                        </Link>
                    </UserRole>
                    <UserRole role='admin'>
                        <Link to="/show/settings" className={`${isActive('/show/settings')}`}>
                            <MdOutlineSettings className="w-6 h-6" />
                        </Link>
                    </UserRole>
                </div>
            </div>
            <div className="flex flex-col items-center space-y-4">
                <DropdownMenu>
                    <DropdownMenuTrigger className='outline-none'>
                        <div className="overflow-hidden outline-none rounded-full w-11 h-11 relative select-none cursor-pointer bg-secondary justify-center items-center flex hover:text-primary-foreground hover:bg-primary">
                            <span className='font-bold text-lg'>{`${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`}</span>
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent side='right' align='end' sideOffset={10}>
                        <div className='flex flex-col gap-1 p-2 text-secondary-foreground'>
                            <span className='text-md font-bold'>{user?.firstName} {user?.lastName}</span>
                            <span className='text-xs text-secondary-foreground/80'>{user?.email}</span>
                            <span className='text-[12px] text-secondary-foreground/60 capitalize'>{UserRoles[user?.role]}</span>
                        </div>
                        <DropdownMenuSeparator />
                        <DropdownMenuLabel>Accounts</DropdownMenuLabel>
                        {user?.accounts.map((account) => (
                            <DropdownMenuCheckboxItem checked={user?.account._id === account._id} disabled={user?.account._id === account._id} onCheckedChange={() => changeAccount(account._id)} key={account._id}>{account.name}</DropdownMenuCheckboxItem>
                        ))}
                        
                        <UserRole role='admin'>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem asChild>
                                    <Link to="/show/account">Account Settings</Link>
                                </DropdownMenuItem>
                            </UserRole>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={logout}>Log out</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </div>
        {showsVisible && <div className='absolute top-0 left-0 w-screen h-screen bg-background/80 z-50 flex pl-20' onClick={() => setShowsVisible(false)}>
            <div className='flex flex-col items-stretch border-x h-screen w-full max-w-96 bg-background'>
                <div className='flex items-center gap-2 px-4 h-20'>
                    <h1 className='text-2xl font-bold border-l-4 border-primary pl-4'>Shows</h1>
                </div>
                <div className='flex flex-col flex-1 overflow-y-auto px-2'>
                    {shows.map((s) => (
                        <div key={s._id} className='flex gap-4 rounded-md cursor-pointer p-4 items-center hover:bg-secondary' onClick={() => switchShow(s._id)}>
                            <div className='relative aspect-square w-14 h-14 rounded-full overflow-hidden bg-secondary justify-center items-center flex'>
                                {!s.thumbnail_url && <span className='text-secondary-foreground font-bold text-xl'>{s.name.charAt(0)}</span>}
                                {s.thumbnail_url &&  <img src={s.thumbnail_url} alt={s.name} loading="lazy" decoding="async" style={{position:'absolute',width:'100%',height:'100%',objectFit:'cover'}} className='object-cover' />}
                            </div>
                            <span className='text-md text-secondary-foreground'>{s.name}</span>
                        </div>
                    ))}

                    <div  className='flex gap-4 rounded-md cursor-pointer p-4 items-center hover:bg-secondary'>
                        <div className='relative aspect-square w-14 h-14 rounded-full overflow-hidden border-2 border-secondary border-dashed justify-center items-center flex'>
                            <MdOutlineAdd className='w-6 h-6' />
                        </div>
                        <span className='text-md text-secondary-foreground'>New Show</span>
                    </div>
                </div>
            </div>
        </div>}
    </nav>
  )
} 